import React from "react";
import Banner from "./Banner";
import Missonvission from "./Missonvission";

const About = () => {
  return (
    <>
      <Banner />

      <section className="px-4 sm:px-6 md:px-16 lg:px-24 py-10">
        <h1 className="text-2xl sm:text-3xl font-bold text-center mb-6 underline">
          About Us
        </h1>
        <p className="text-sm sm:text-base text-gray-700 leading-relaxed text-justify">
          As an ABS-certified, ISO 9001, 14001 and 45001 compliant Ship Management Company
          based in Mumbai, India, we deliver a variety of services to meet the
          diverse needs of the maritime industry. Our seasoned shore staff along
          with our Indian and Marshall Islands DOCs and an Indian RPSL license,
          ensures we fully comply with our vessel owner's requirements. With the
          maritime regulatory landscape continually evolving, particularly
          concerning stringent decarbonisation goals, more stringent RightShip
          inspection requirements and the new SIRE 2.0 regime for tankers, we
          are proactively adopting a holistic approach designed to benefit all
          stakeholders. Our organization is dedicated to swiftly and effectively
          adapting to emerging requirements in this dynamic market. Ultimately,
          our mission is to provide exceptional service quality, ensure our
          fleet operates with full statutory compliance, uphold operational
          excellence, and cultivate strong stakeholder satisfaction.
        </p>
      </section>

      <Missonvission />
    </>
  );
};

export default About;
